// client/src/utils/sessionCheck.ts
//
// Second opinion before a 401 signs someone out. GET /api/auth/me reads the
// HttpOnly auth_session cookie, so it answers "is this browser still signed
// in?" independently of whatever Bearer token the failing request carried.
// Only a 401/403 from /me counts as signed out; a network error or 5xx says
// nothing about the session, so we keep the user signed in.
import axios from 'axios';

export async function checkSessionAfter401(): Promise<{ stillSignedIn: boolean; meStatus: number | string }> {
  try {
    const res = await axios.get('/api/auth/me', { withCredentials: true });
    return { stillSignedIn: true, meStatus: res.status };
  } catch (error) {
    const status = axios.isAxiosError(error) ? error.response?.status : undefined;
    if (status === 401 || status === 403) {
      return { stillSignedIn: false, meStatus: status };
    }
    return { stillSignedIn: true, meStatus: status ?? 'network_error' };
  }
}
